import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/share/download.svg';

const DownloadIcon = (props) => (
   <Icon { ...props }/>
);

export default DownloadIcon;
